<template>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      height: calc(100%);
    "
  >
    <div class="t_sp_box">
      <div v-if="finishfont" class="t_sp_title">审核完成，请返回首页重新登录。</div>
      <div v-else class="t_sp_title">贵单位注册信息正在审批中，请耐心等待。</div>
      <el-steps
        v-if="show"
        :active="nowstep"
        style="width: 1000px"
        align-center
      >
        <el-step title="已完成">
          <template slot="description">
            <span>注册账号<br>{{ loadmsg.cjsj }}</span>
          </template>
        </el-step>
        <el-step title="已完成">
          <template slot="description">
            <span>单位信息账号<br>{{ loadmsg.rwsqsj }}</span>
          </template>
        </el-step>
        <el-step
          v-for="(item, index) in loadmsg.ysplc"
          :key="item+index"
          title="已审批"
        >
          <template slot="description">
            <span>{{ item.dqbmLabel }}<br>{{ item.spsj }}</span>
          </template>
        </el-step>
        <el-step title="正在审批中">
          <template slot="description">
            <span>{{ loadmsg.dqbmLabel }}</span>
          </template>
        </el-step>
        <el-step
          v-for="(item, index) in loadmsg.wspLchj"
          :key="index"
          title="待审批"
        >
          <template slot="description">
            <span>{{ item.dwjbLabel }}</span>
          </template>
        </el-step>
        <el-step title="审批完成">
          <!-- <template slot="description">
            <span>注册账号<br />{{ loadmsg.cjsj }}</span>
          </template> -->
        </el-step>
        <!-- <el-step title="步骤4" description="这是一段很长很长很长的描述性文字"></el-step>
                    <el-step title="步骤5" description="这是一段很长很长很长的描述性文字"></el-step> -->
      </el-steps>
      <el-button
        v-preventReClick
        style="background-color: #4170ff; color: white; margin-top: 50px"
        @click="back"
      >返回登录</el-button>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import { qyxxZzsp } from '@/assets/js/common.js'
import { removeToken } from '@/utils/tool'

export default {
  name: 'Spload',
  components: {
    // Header,
  },
  data() {
    return {
      loadmsg: [],
      show: false,
      nowstep: null,
      finishfont: false
    }
  },
  created: function() {},
  mounted: function() {
    this.load()
  },
  methods: {
    back() {
      removeToken()
      this.$router.push('/login')
    },
    load() {
      qyxxZzsp().then((e) => {
        this.loadmsg = e.data.data
        this.show = true
        this.finishfont = e.data.data.finishFlag
        if (e.data.data.finishFlag) {
          this.nowstep = e.data.data.ysplc.length + 4
        } else {
          this.nowstep = e.data.data.ysplc.length + 3
        }
      })
    }
  }
}
</script>

<style scoped>
.t_sp_box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.t_sp_title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 100px;
}
</style>
